module.exports = __webpack_public_path__ + "img/turn-slight-right.154b3446.svg";